// Detecção de bandeira por prefixo IIN + formatação do número.
// Só apresentação: o valor cru (só dígitos) continua indo pro tokenizecard.js/fetch.

// ponytail: regex por faixa de IIN cobre Visa/Master/Amex/Elo/Diners; sem lib.
const BRANDS = [
  { brand: 'amex', test: /^3[47]/ },
  { brand: 'diners', test: /^3(?:0[0-5]|[68])/ },
  { brand: 'elo', test: /^(4011|4312|4389|4514|4576|5041|5066|5067|509|6277|6362|6363|650|6516|6550)/ },
  { brand: 'mastercard', test: /^(5[1-5]|2[2-7])/ },
  { brand: 'visa', test: /^4/ },
];

export function detectBrand(rawNumber) {
  const digits = (rawNumber || '').replace(/\D/g, '');
  if (!digits) return null;
  const match = BRANDS.find((b) => b.test.test(digits));
  return match ? match.brand : null;
}

// Amex agrupa 4-6-5; demais em blocos de 4.
export function formatCardNumber(rawNumber) {
  const digits = (rawNumber || '').replace(/\D/g, '').slice(0, 19);
  const isAmex = /^3[47]/.test(digits);
  if (isAmex) {
    const g = [digits.slice(0, 4), digits.slice(4, 10), digits.slice(10, 15)].filter(Boolean);
    return g.join(' ');
  }
  return digits.replace(/(.{4})/g, '$1 ').trim();
}

export const BRAND_LABEL = {
  visa: 'VISA',
  mastercard: 'Mastercard',
  amex: 'Amex',
  elo: 'Elo',
  diners: 'Diners',
};

// Marca da bandeira em SVG inline (nítido em qualquer zoom, sem imagem externa).
export function BrandMark({ brand, className = 'h-6 w-auto' }) {
  if (!brand || !BRAND_LABEL[brand]) return null;
  const base = { width: 38, height: 24, viewBox: '0 0 38 24', className, role: 'img', 'aria-label': BRAND_LABEL[brand] };
  if (brand === 'mastercard') {
    return (
      <svg {...base}>
        <rect width="38" height="24" rx="4" fill="#fff" />
        <circle cx="15" cy="12" r="6.5" fill="#EB001B" />
        <circle cx="23" cy="12" r="6.5" fill="#F79E1B" />
        <path d="M19 7.3c1.6 1.2 2.6 2.9 2.6 4.7s-1 3.5-2.6 4.7c-1.6-1.2-2.6-2.9-2.6-4.7s1-3.5 2.6-4.7z" fill="#FF5F00" />
      </svg>
    );
  }
  if (brand === 'visa') {
    return (
      <svg {...base}>
        <rect width="38" height="24" rx="4" fill="#fff" />
        <text x="19" y="16" textAnchor="middle" fontFamily="Helvetica, Arial, sans-serif" fontSize="10" fontStyle="italic" fontWeight="bold" fill="#1A1F71">VISA</text>
      </svg>
    );
  }
  if (brand === 'amex') {
    return (
      <svg {...base}>
        <rect width="38" height="24" rx="4" fill="#016FD0" />
        <text x="19" y="15.5" textAnchor="middle" fontFamily="Helvetica, Arial, sans-serif" fontSize="8.5" fontWeight="bold" fill="#fff">AMEX</text>
      </svg>
    );
  }
  if (brand === 'elo') {
    return (
      <svg {...base}>
        <rect width="38" height="24" rx="4" fill="#1b1b1b" />
        <text x="19" y="16" textAnchor="middle" fontFamily="Helvetica, Arial, sans-serif" fontSize="10" fontWeight="bold" fill="#fff">elo</text>
      </svg>
    );
  }
  // diners
  return (
    <svg {...base}>
      <rect width="38" height="24" rx="4" fill="#fff" />
      <text x="19" y="15.5" textAnchor="middle" fontFamily="Helvetica, Arial, sans-serif" fontSize="7" fontWeight="bold" fill="#0079BE">DINERS</text>
    </svg>
  );
}
